module.exports = __webpack_public_path__ + "img/keyboard.5ef81575.svg";